import * as React from 'react'

import type AccessGroup from 'modules/core/store/models/AccessGroup'

import type { Employees } from 'modules/employees/store/collections/employees'

import Table from './Table'

interface Props {
  accessGroup?: AccessGroup | null | undefined
  surveyId: number
  employees: Employees
}

export default function AccessGroupTable({ accessGroup, surveyId, employees }: Props) {
  if (!accessGroup) return null

  return <Table accessGroup={accessGroup} surveyId={surveyId} employees={employees} />
}
